import styled from "styled-components";

export const Wrapper = styled.form`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100%;
`;

export const Column = styled.div`
  &:first-of-type {
    border-right: 1px solid #3d3d3d;
  }

  padding: 1.5rem;
  height: 100%;
`;

export const FormBody = styled.div`
  margin-top: 1.7rem;
`;

export const FormGroup = styled.div`
  margin-bottom: 1.4rem;

  input {
    width: 100%;
  }
`;
